import { render } from "./Lists.vue?vue&type=template&id=474fa91b&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"

import "./Lists.vue?vue&type=style&index=0&id=474fa91b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474fa91b"],['__file',"src/components/lists/Lists.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "474fa91b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('474fa91b', __exports__)) {
    api.reload('474fa91b', __exports__)
  }
  
  module.hot.accept("./Lists.vue?vue&type=template&id=474fa91b&scoped=true", () => {
    api.rerender('474fa91b', render)
  })

}


export default __exports__